import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define a type for the slice state
interface TopSearchBarState {
  itemsRecentsSearches: Array<any>;
  filters: {
    transportModes: Array<number>;
    sellingCategories: Array<number>;
    otherCategories: [];
    sections: Array<number>;
  };
}

// Define the initial state using that type
const initialState: TopSearchBarState = {
  itemsRecentsSearches: (function getItemsRecentsSearches() {
    return JSON.parse(localStorage.getItem('itemsRecentsSearches') || '[]');
  })(),
  filters: {
    transportModes: [],
    sellingCategories: [],
    otherCategories: [],
    sections: [],
  },
};

export const topSearchBarSlice = createSlice({
  name: 'topSearchBarSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateItemsRecentsSearches: (state, action) => {
      state.itemsRecentsSearches = action.payload;
      localStorage.setItem('itemsRecentsSearches', JSON.stringify(state.itemsRecentsSearches));
    },
    updateFiltersTransportModes: (state, action) => {
      state.filters.transportModes = action.payload;
    },
    updateFiltersOtherCategories: (state, action) => {
      state.filters.otherCategories = action.payload;
    },
    updateFiltersSellingCategories: (state, action) => {
      state.filters.sellingCategories = action.payload;
    },
    updateFiltersSections: (state, action) => {
      state.filters.sections = action.payload;
    },
    resetFilters: (state) => {
      state.filters.transportModes = [];
      state.filters.otherCategories = [];
      state.filters.sellingCategories = [];
      state.filters.sections = [];
    },
  },
});

export const {
  updateItemsRecentsSearches,
  updateFiltersSellingCategories,
  updateFiltersOtherCategories,
  updateFiltersTransportModes,
  resetFilters,
  updateFiltersSections,
} = topSearchBarSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const topSearchBarState = (state: RootState) => state.topSearchBar;
export const topSearchBarItemsRecentsSearchesState = (state: RootState) =>
  state.topSearchBar.itemsRecentsSearches;
export const topSearchBarFiltersState = (state: RootState) => state.topSearchBar.filters;

export default topSearchBarSlice.reducer;
